import _regeneratorRuntime from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/shupian/qds-scrmnet-0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { env } from '@/config';

/**
 * @description:获取当前外部联系人userid
 * **/
var getUserId = function getUserId() {
  return new Promise(function (resolve, reject) {
    if (env === 'dev') {
      wx.invoke('getCurExternalContact', {}, function (res) {
        console.log('当前外部联系人userID', res.userId);
        resolve(res.userId);
      });
    } else {
      resolve('MaDMaN');
    }
  });
};
var state = {
  userId: '',
  disconnect: false
};
var mutations = {
  SET_USER_ID: function SET_USER_ID(state, id) {
    state.userId = id;
  },
  SET_DISCONNECT: function SET_DISCONNECT(state, disconnect) {
    state.disconnect = disconnect;
  }
};
var actions = {
  setUserId: function setUserId(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, id;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return getUserId();
          case 3:
            id = _context.sent;
            commit('SET_USER_ID', id);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};